const MINUTE_MS = 60_000
const HOUR_MINUTES = 60
const DAY_HOURS = 24

/**
 * Formats an elapsed GPS age without rounding it up. A relative label must describe the actual
 * age of the point: 95 minutes is one hour and 35 minutes, not two hours.
 */
export function formatRelativeTrackingAge(elapsedMs: number): string {
  const safeElapsedMs = Number.isFinite(elapsedMs) ? Math.max(0, elapsedMs) : 0
  const totalMinutes = Math.floor(safeElapsedMs / MINUTE_MS)
  if (totalMinutes < 1) return 'только что'

  const days = Math.floor(totalMinutes / (DAY_HOURS * HOUR_MINUTES))
  const hours = Math.floor((totalMinutes % (DAY_HOURS * HOUR_MINUTES)) / HOUR_MINUTES)
  const minutes = totalMinutes % HOUR_MINUTES
  const parts: string[] = []

  if (days > 0) parts.push(`${days} дн`)
  if (hours > 0) parts.push(`${hours} ч`)
  if (minutes > 0) parts.push(`${minutes} мин`)

  return `${parts.join(' ')} назад`
}

/** Returns null for an invalid timestamp; callers choose their own empty-state wording. */
export function formatRelativeTrackingTimestamp(timestamp: string | Date, now = Date.now()): string | null {
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
  if (Number.isNaN(date.getTime())) return null
  return formatRelativeTrackingAge(now - date.getTime())
}
